<template>
  <section class="project-details-area pt-120 pb-70">
    <div class="container">
      <!--<div class="row">
        <div class="col-xxl-12">
          <div class="project-big-thumb">
            <img
              src="../../assets/img/portfolio/portfolio-big-img.jpg"
              alt=""
            />
          </div>
        </div>
      </div>-->
      <div class="row">
        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-12">
          <div class="p-details-content mb-40">
            <h3>Field Level Access Rights</h3>
            <p>
              Access to eForm can be customized at the field level. One might
              have some access rights for one part of the eForm and some other
              rights on a different part.
            </p>
            <p>
              This enables the support of several processes using a single
              simple platform instead of multiple complex tools.
            </p>

            <p>Those processes include but are not limited to:</p>
            <li>• Clinical study data collection</li>
            <li>• Patient Report Outcome data collection</li>
            <li>
              • Organization of the drug or device provisioning to support a
              trial
            </li>
            <li>• Monitoring Visit Reporting</li>
            <li>• Electronic Trial Master File</li>
            <li>• Sample Management</li>
            <li>• eConsent</li>
            <li>• Randomization</li>
            <p></p>
            <p>
              There is no limit to the possibilities, feel free to ask our
              engineers
            </p>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
          <div class="platform-big-thumb">
            <img src="../../assets/img/platform/Monitoring.png" alt="" />
          </div>
          <!--<div class="sidebar-wrap mb-40">
                           <div class="sidebar-right">
                              <div class="sidebar-single">
                                    <label>Clients:</label>
                                    <span>Jessica Brown</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Category:</label>
                                    <span>Design, Development</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Value:</label>
                                    <span>Jessica Brown</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Date:</label>
                                    <span>20 June, 2022</span>
                              </div>
                           </div>
                        </div>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PlatformDetailsAreaAccessRights",
};
</script>